export default __webpack_public_path__ + "98bbbbc3c50f6da1c6dce3e3d80c10ae.gif";